<template>
    <b-container fluid>
        <b-row v-if="purpose==0">
            <b-col cols="6">
                <b-row>
                    <b-col>
                    服務基本資料
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <b-table stacked :items="basicinfoitems"></b-table>
                    </b-col>
                </b-row>
            </b-col>
            <b-col cols="6">
                <b-row>
                    <b-col>
                    回傳資訊
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <b-table :fields="fields" :items="responseinfoitems"></b-table>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
        <b-row v-else>
            <b-col cols="4">
                <b-row>
                    <b-col>
                    服務基本資料
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <b-table stacked :items="basicinfoitems"></b-table>
                    </b-col>
                </b-row>
            </b-col>
            <b-col cols="4">
                <b-row>
                    <b-col>
                    回傳資訊 - 有查詢參數
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <b-table :fields="fieldswithparams" :items="responseinfowitparamitems"></b-table>
                    </b-col>
                </b-row>
            </b-col>
            <b-col cols="4">
                <b-row>
                    <b-col>
                    回傳資訊 - 無查詢參數
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <b-table :fields="fields" :items="responseinfoitems"></b-table>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
export default {
    name: "OpenInfo",
    props: {
        purpose: {
            type: Number,
            default: 0
        },
        basicinfoitems: {
            type: Array,
            default: () => []
        },
        responseinfoitems: {
            type: Array,
            default: () => []
        },
        responseinfowitparamitems: {
            type: Array,
            default: () => []
        },
    },
    data() {
        return {
            fields : 
            [ 
                {       
                    key: 'name',
                    label: '名稱'
                },
                {
                    key: 'description',
                    label: '說明'
                }
            ],
            fieldswithparams : 
            [ 
                {       
                    key: 'name',
                    label: '參數名稱'
                },
                {       
                    key: 'ifrequired',
                    label: '必選填'
                },
                {
                    key: 'description',
                    label: '說明'
                }
            ],
        }
    }
}
</script>